import { reactive, toRefs, onBeforeMount, onBeforeUnmount, onMounted, ref, computed,Ref, nextTick, watch,getCurrentInstance  } from 'vue'
import { useStore } from 'vuex'
import useReceiveMessage, { getCanvasLimitHeight } from '@/hooks/useReceiveMessage'
import useLoading3D from '@/hooks/useLoading3D'
import useSpeechSynthesis from '@/hooks/useSpeechSynthesis'
import { $enum, $config, $tips } from '@/global'
import type { CountdownProps } from 'naive-ui'
import {enterOrExitUavSimulateModule, resetView, switchUnlockUav,forceGainFocus} from '@/webapi'
import { createTraining } from '@/service'
import CircleDrawer from '@/utils/drawer/CircleDrawer'

interface IFlyingPropps {}

interface IFlyingEmit {
    (event: 'onBack'): void
}

enum PageName {
    加载中=1,
    飞行=2,
    成绩=3,
    提示=4
}

enum MassageType {
    无=0,
    悬停=1,
    自转=2,
    八字=3,
    降落=4,
    超时=5,
    解锁=6
}

//科目模式
enum SceneMode {
    无=0,
    悬停=1,
    自旋=2,
    八字=3,
    全科=4,
}


const colorMap: Record<string, string> = {
    'height': '#6BA4FF',
    'position': '#D57D0F',
    'timeDeviation': '#46B65B',
    'headAngle': '#FDE043',
    'angle': '#D279D3',
    'speed': '#38B6C7'
}
export default function useFlying(
    props: IFlyingPropps,
    emit: IFlyingEmit,
    timeBoxRef:any,
    timeBox:any,
    progressRef:any,
    countdownRef:any,
    flyCanvasRef:any,
    gradCanvasRef:any,
    errorCountdownRef:any,
    flyDeviationInfoRef:any,
): any {
    const store = useStore()
    const { proxy } = getCurrentInstance() as any
    const typeMap = new Map([
        ['notifyRunningParam', 'notifyRunningParam'], //运行数据回调
        ['loadResourceFail', 'loadResourceFail'], //加载模型失败
        ['loadSceneResource', 'loadSceneResource'], //加载模型完成
        ['modelLoading', 'modelLoading'], //加载模型进度
        ['initializeEngineProgress', 'initializeEngineProgress'], //引擎初始化
        ['extraLoadModelFiles','extraLoadModelFiles'], //额外的模型文件列表
        ['exitSimulateModuleSuccess','exitSimulateModuleSuccess'], //退出模拟模块成功
        ['rotatePartOneComplete','rotatePartOneComplete'], //旋转第一部分完成

    ])
    const state = reactive({
        sceneImage: $config.FILE_ROOT_PATH + store.state.persistence.currentUavInfo.sceneImageUrl,
        uavId: store.state.persistence.currentUavInfo.uavId,
        nestId: store.state.persistence.currentUavInfo.nestId,
        trainingId: store.state.persistence.currentUavInfo.trainingId,
        stationdId: store.state.persistence.stationId,
        sceneInfo:store.state.persistence.currentUavInfo.sceneInfo,
        resourceFileList:store.state.persistence.currentUavInfo?.resourceFileList[0] || [],
        connectStatus: $enum.SWITCH_STATUS.OFF, // 遥控器连接状态
        lockStatus:$enum.SWITCH_STATUS.OFF,
        propgressTimer: null as any, // 进度条计时器
        step: 1, // 进度条步长
        containerWidth: 0 as any, // 容器宽度
        isComputing: false, // 是否计算中
        isShowGrad:false,
        currentPage:PageName.加载中, //当前页面,
        pixiApp: store.state.viewData.pixiInstance, //pixi实例
        loading3D:{
            title:store.state.persistence.currentUavInfo.sceneInfo?.sceneSubTypeName,
            description:store.state.persistence.currentUavInfo.sceneInfo?.typeDescription,
            pageType:store.state.persistence.currentUavInfo.parentName,
        },
        finish:false,//是否训练完成
        gradScore:0,//得分
        evaluate:false,
        drawer:null as any, // 圆形绘制器实例
        isShowMessage:false, //是否显示消息
        alarmTimeCount:0,//消息显示时间
        totalTime:0,//总时间
        pageVisible:true, //页面是否可见
        engineProgress:0,

        currentTask:1, //当前任务
        taskMode:store.state.persistence.currentUavInfo.sceneInfo?.difficultyType, //任务模式 0，简单；1：困难
        windSpeed:['0.1-0.5','0.6-1.0','1.1-2.0'],//三关风速列表
        windDirction:['北风','东北风','东风','东南风','南风','西南风','西风','西北风'],//三关风向列表
        windDirectionIndex:null as any,
        allTotalTime:0,
        time:null as any,
        timer:null as any, // 倒计时计时器
        fpsStatus:60,
        showElectronic:true,
        collisionAlarm:false,
        crash:false,
        currentWind:'0.0',
        canSetFps:true,
        aiCoachFinal:null as any,
        aiCoachRealtime:null as any,
        aiCoachSettlementData:null as any,
        aiCoachRoundSettlementList:[] as any[],
        flyDeviationViewMode:$enum.FlyDeviationViewMode.卡片,
        forbidAiCoach:store.state.persistence.breadcrumb[0]?.permissionLevel,
        backByExitSimulateModule:false,
    })
    const operationPrompt = reactive({
        spinCompleted:false,//自旋完成
        delayTime:3000,
        hoverStarted:false,
    })

    const flyingState = reactive({
        evaluateStatus:{
            height:false,
            position:false,
            time:0,
            angle:false,
            angleMaxSpeed:false,
            angleMinSpeed:false,
            calculateAngleSpeed:false, //到达中心桶并且角速度第一次超过最小值时改为true
            maxSpeed:false,
            minSpeed:false,
            calculateMinSpeed:false, //到达中心桶并且最小速度第一次超过最小值时改为true
            collisionAlarm:false,
            onGroundAlarm:false
        },
        totalSeconds: -1, // 飞行总时间 秒
        currentSeconds: 0, // 当前时间 秒
        uavStatusList: [],
        currentStepIndex:0,
        altitude:0,  //高度
        horizonalSpeed:0,//速度
        courseAngle:0, //航向角
        realTimeAngleOffset:0,//航向夹角
        angularSpeed:0,//角速度
        uavIconAngle:0, //无人机图标角度
        isShowAlarm:false,
        currentMessage:MassageType.无,
        onGround:false,
        arriveCenter:0,//是否到达中心
        flyingInfo:{} as any,
        isReady:false,
        resetting:0,
    });

    const sceneMode = computed(() => {
        let mode = SceneMode.无;
        if(state.sceneInfo && state.sceneInfo?.sceneSubTypeName){
            if(/悬停/.test(state.sceneInfo?.sceneSubTypeName)){
                mode = SceneMode.悬停;
            }else if(/自旋/.test(state.sceneInfo?.sceneSubTypeName)){
                mode = SceneMode.自旋;
            }else if(/8字/.test(state.sceneInfo?.sceneSubTypeName)){
                mode = SceneMode.八字;
            }else if(/全科/.test(state.sceneInfo?.sceneSubTypeName)){
                mode = SceneMode.全科;
            }
        }
        return mode;
    });

    const getRoundWeight = (roundIndex:number, difficultyType:number, roundTotal = 3) => {
        if(!Number.isFinite(roundIndex) || roundIndex <= 0) return 1;
        if(difficultyType === 1 && roundTotal === 3){
            const weights = [0.2, 0.3, 0.5];
            return weights[Math.min(Math.max(roundIndex, 1), 3) - 1];
        }
        return 1 / Math.max(1, roundTotal);
    }

    const aggregateRoundSettlement = (rounds:any[]) => {
        if(!Array.isArray(rounds) || !rounds.length){
            return null;
        }
        const valid = rounds.filter((x:any) => x && x.result && x.result.radar);
        if(!valid.length){
            return null;
        }
        const allPass = valid.every((x:any) => x.isPass);
        // 使用最后一次的雷达图和总结
        const last = valid[valid.length - 1].result;
        const radar = last.radar;
        const avg = (Object.values(radar).reduce((s:number, v:any) => s + (Number(v) || 0), 0) / 5);
        const rating = !allPass ? '较差' : (avg >= 0.8 ? '优秀' : '良好');
        return {
            rating,
            ratingSource: !allPass ? 'pass_fail_gate' : 'ai_dims',
            radar,
            radarMapping: last.radarMapping,
            aiDimensions: {
                stability: radar.flight_stability,
                responsiveness: radar.stick_proficiency,
                disturbance_recovery: radar.anti_disturbance,
                boundary_control: radar.error_correction,
                precision: radar.deviation_control
            },
            flightConclusion: String(last.flightConclusion || '').slice(0, 60),
            trainingSuggestion: String(last.trainingSuggestion || '').slice(0, 60)
        };
    }

    const upsertRoundSettlement = (roundIndex:number, isPass:boolean, result:any) => {
        const roundTotal = state.windSpeed?.length || 3;
        const weight = getRoundWeight(roundIndex, Number(state.taskMode), roundTotal);
        const nextList = (state.aiCoachRoundSettlementList || [])
            .filter((item:any) => Number(item?.roundIndex) !== Number(roundIndex));
        nextList.push({
            roundIndex,
            weight,
            isPass,
            result
        });
        nextList.sort((a:any, b:any) => Number(a.roundIndex) - Number(b.roundIndex));
        state.aiCoachRoundSettlementList = nextList;
        const aggregated = aggregateRoundSettlement(nextList);
        state.aiCoachSettlementData = aggregated || result || null;
    }

    const { speak } = useSpeechSynthesis()

    const updateFlyingInfo = (data:any) => {
        const max = Number(data?.maxValue || 0);
        const min = Number(data?.minValue || 0);
        if(data?.value>max&&data?.value<max+0.01){
            data.value = max+0.01
        }
        let value = Number(data?.value || 0);
        let realTimeValue = Number(data?.realTimeValue || 0);
        let lowerValue:any = Number(data?.lowerValue || 0);
        let higherValue:any = Number(data?.higherValue || 0);
        let range = max - min;
        let leftValue = Math.max(min, lowerValue);
        let rightValue = Math.min(max, higherValue);
        let progress = Math.min(1, (rightValue - leftValue) / range) * 100;
        let color = lowerValue < min || higherValue > max ? '#E70102' : '#2174FF ';
        let left = (leftValue - min) / range * 100;
        return {value,progress,max,min,name:data?.name, lowerValue, higherValue,color,left,realTimeValue,id:data?.id};
    }

    const updateFlightMetric = (data:any, metric:any,unit:string) => {
        if(!data) return;
        if(Array.isArray(data)){
            if(data.length){
                let arr:any[] = []
                data.forEach(item=>{
                    let {value,max,min,name, lowerValue, higherValue,realTimeValue,id} = updateFlyingInfo(item);
                    if(metric == 'timeDeviation' && sceneMode.value == SceneMode.悬停){
                        name = '用时偏差'
                        max = min
                    }
                    arr.push({
                        name,
                        id,
                        value:value.toFixed(0),
                        realTimeValue:realTimeValue.toFixed(0),
                        max,
                        min,
                        lowerValue:lowerValue.toFixed(2),
                        higherValue:higherValue.toFixed(2),
                        progress: 0,
                        color:'',
                        left:0,
                        unit
                    });
                })
                flyingState.flyingInfo[metric] = arr
            }else{
                let name = flyingState.flyingInfo[metric][0]?.name
                flyingState.flyingInfo[metric] = [{
                    name,
                    id:flyingState.flyingInfo[metric][0]?.id,
                    value:0,
                    realTimeValue:0,
                    max:0,
                    min:0,
                    lowerValue:0,
                    higherValue:0,
                    progress: 0,
                    color:'',
                    left:0,
                    unit
                }]
            }
        }else{
            let {value,progress,max,min,name, lowerValue, higherValue,color,left,realTimeValue,id} = updateFlyingInfo(data);
            if(metric == 'headAngle'){
                //夹角偏差
                lowerValue = lowerValue.toFixed(1)
                higherValue = higherValue.toFixed(1)
            }else{
                lowerValue = lowerValue.toFixed(2)
                higherValue = higherValue.toFixed(2)
            }
            flyingState.flyingInfo[metric] = {
                name,
                id,
                value,
                realTimeValue,
                max,
                min,
                lowerValue,
                higherValue,
                progress,
                color,
                left,
                unit
            };
        }
    }

    const gradTotalTime = computed(() => {
        const totalSeconds = state.totalTime;
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = Math.floor(totalSeconds - minutes * 60); // 关键修改：计算真正的剩余秒数
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    });

    const allPassTime = computed(() => {
        const totalSeconds = state.allTotalTime;
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = Math.floor(totalSeconds - minutes * 60); // 关键修改：计算真正的剩余秒数
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    });

    const loadingProgess = computed(() => {
        if(engineInitialized.value){
            return loadingState.progressValue;
        }else{
            return (state.engineProgress * 100).toFixed(2);
        }
    });

    //当前风向
    const currentWindDirection = computed(() => {
        if(state.taskMode == 0){
            return '无'
        }
        return state.windDirction[state.windDirectionIndex];
    });

    //当前风速
    const currentWindSpeed = computed(() => {
        if(state.taskMode == 0){
            return '无'
        }
        return state.windSpeed[state.currentTask-1].split('-')[1];
    });


     ///////////////////////////////////////////////////////  事件

     const { loadingState, setLoadingStatus,engineInitialized, handleOpenPDF,setExtraFileMap, showOrHideEngineView } = useLoading3D(state.stationdId, state.resourceFileList, proxy)

     const { handleOpenSettingFullscreen, handleBack } = useReceiveMessage(typeMap, async (type: string, data: any) => {
        if (type === 'notifyRunningParam') {
            const {horizonalSpeed, yaw, taskData, joyStickMode, unLockStatu,yawAngleSpeed,homingData,onGround,openGuidStatu,notifyKeyList,isReady,finishReset,fps,currentWindSpeed} = data.data || {}
            const { stepNameList, currentStepIndex, evaluateData,finish,targetTime, currentTime,isPass, mapYaw,mapPosition,totalTime,overLimit,arriveCenter,collisionAlarm, crash, onGroundAlarm,realTimeAngleOffset, aiCoachRealtime, aiCoachFinal, aiCoachSettlementData  } = taskData || {}
            Object.assign(state,{
                lockStatus:unLockStatu,
                connectStatus:joyStickMode,
                totalTime:totalTime,
                collisionAlarm,
                crash,
                currentWind:currentWindSpeed?.toFixed(1) || '0.0',
            })
            if(state.canSetFps){
                state.fpsStatus = fps;
            }
            if (notifyKeyList && notifyKeyList.length > 0)
            {
                notifyKeyList.forEach((item: string) => {
                    if(item == "Escape")
                    {
                        handleBack('Escape');
                    }else if(item == "F11"){
                        window.listenEvent.emit('toggle-full-screen');
                    }
                });
            }
            if (finishReset) {
                if (state.drawer) {
                    state.drawer.reset(mapYaw);
                }
            }
            state.aiCoachRealtime = aiCoachRealtime ?? null;
            state.aiCoachFinal = aiCoachFinal ?? null;
            state.aiCoachSettlementData = aiCoachSettlementData ?? null;

            if(crash){
                if(state.currentPage == PageName.飞行){
                    proxy?.vknMessage.close();
                    state.currentPage = PageName.提示
                }
            }else{
                if(state.currentPage == PageName.提示){
                    state.currentPage = PageName.飞行;
                }
            }

            if(!finish){
                if(state.finish){
                    state.finish = false;
                }
                if((currentStepIndex > 0 || !hasFlowStep(stepNameList, '解锁')) && state.isShowMessage && overLimit == 0){
                    state.isShowMessage = false;
                }
                if(!flyingState.arriveCenter && arriveCenter){
                    flyingState.arriveCenter = arriveCenter;
                }
                normalPrompt({currentStepIndex,overLimit,stepNameList,arriveCenter,targetTime,isReady})
                 // 一次性更新飞行状态
                const prevIsReady = flyingState.isReady;
                Object.assign(flyingState, {
                    uavStatusList: stepNameList,
                    currentStepIndex,
                    altitude: homingData?.verticalDistance?.toFixed(2) || '0.00',
                    horizonalSpeed: horizonalSpeed?.toFixed(2) || '0.00',
                    angularSpeed: yawAngleSpeed.toFixed(1) || '0.0',
                    courseAngle: yaw?.toFixed(0) || '0',
                    realTimeAngleOffset:realTimeAngleOffset !== undefined?realTimeAngleOffset?.toFixed(0) || '0':undefined,
                    totalSeconds:targetTime,
                    currentSeconds:currentTime?.toFixed(0),
                    uavIconAngle:mapYaw?.toFixed(0),
                    onGround:onGround,
                    isReady:isReady,

                })
                // 广播 isReady 状态变化给布局组件（仅在状态变化时广播）
                if (isReady && isReady !== prevIsReady) {
                    window.listenEvent.emit('is-ready-change', isReady);
                }

                if(!state.drawer && evaluateData?.["positionOffset"] && state.showElectronic){
                    const w = evaluateData?.["positionOffset"].maxValue * 10 * 2;
                    state.drawer = new CircleDrawer(flyCanvasRef.value,w,{x:mapPosition.x,y:mapPosition.y,yaw:mapYaw})
                }
                if(state.drawer && state.currentPage == PageName.飞行 && unLockStatu ==  $enum.SWITCH_STATUS.ON){
                    state.drawer.updateCompass({
                        x:mapPosition.x,
                        y:mapPosition.y,
                        yaw:mapYaw
                    })
                }
                if(evaluateData && typeof evaluateData == "object"){
                    const {
                        heightOffset,
                        positionOffset,
                        angleOffset,
                        angleSpeedOffset,
                        speedOffset,
                        targetTime,
                        time
                    } = evaluateData;
                    const isFirstInit = Object.keys(flyingState.flyingInfo).length === 0;
                    const shouldUpdate = isFirstInit || flyingState.resetting || (flyingState.arriveCenter && flyingState.currentMessage !== MassageType.降落);
                    if (shouldUpdate) {
                        if(flyingState.resetting){
                            flyingState.resetting --;
                        }
                        if (heightOffset !== undefined) updateFlightMetric(heightOffset, 'height', 'm');
                        if (positionOffset !== undefined) updateFlightMetric(positionOffset, 'position', 'm');
                        if (sceneMode.value === SceneMode.悬停) {
                            if (targetTime !== undefined) updateFlightMetric([targetTime], 'timeDeviation', 's');
                        } else {
                            if (time !== undefined) updateFlightMetric(time, 'timeDeviation', 's');
                        }
                        if (angleOffset !== undefined) updateFlightMetric(angleOffset, 'headAngle', '°');
                        if (angleSpeedOffset !== undefined) updateFlightMetric(angleSpeedOffset, 'angle', '°/s');
                        if (speedOffset !== undefined) updateFlightMetric(speedOffset, 'speed', 'm/s');
                        // 更新曲线数据
                        flyDeviationInfoRef?.value?.updateCurveData?.(flyingState.resetting ==0)
                    }
                }

                abnormalPrompt({evaluateData,yawAngleSpeed,horizonalSpeed,collisionAlarm, onGroundAlarm, overLimit,mapPosition,mapYaw})

            }

            if(state.showElectronic && state.currentTask > 1){
                state.showElectronic = false;
            }

            if(finish && !state.finish){
                if(!state.finish){
                    state.finish = true;
                }
                const roundSettlement = aiCoachSettlementData ?? null;
                state.aiCoachFinal = aiCoachFinal ?? null;
                if(roundSettlement){
                    upsertRoundSettlement(Number(state.currentTask || 1), !!isPass, roundSettlement);
                }
                state.allTotalTime = state.allTotalTime + totalTime
                if(typeof evaluateData == "object" && Object.keys(evaluateData).length > 0 ){
                    updateFlightMetric(evaluateData?.["heightOffset"], 'height','m');
                    updateFlightMetric(evaluateData?.["positionOffset"], 'position','m');
                    if(sceneMode.value == SceneMode.悬停){
                        updateFlightMetric([evaluateData?.["targetTime"]], 'timeDeviation','s');

                    }else{
                        updateFlightMetric(evaluateData?.["time"], 'timeDeviation','s');
                    }
                    updateFlightMetric(evaluateData?.["angleOffset"], 'headAngle','°');
                    updateFlightMetric(evaluateData?.["angleSpeedOffset"], 'angle','°/s');
                    updateFlightMetric(evaluateData?.["speedOffset"], 'speed','m/s');
                }
                abnormalPrompt({evaluateData,yawAngleSpeed,horizonalSpeed,collisionAlarm, onGroundAlarm, overLimit,mapPosition,mapYaw})

                if(isPass){
                    //一次通关通过
                    if(state.currentTask < 3){
                        proxy?.vknMessage.close();
                        showMessage("任务完成，即将开始新的任务", 2500,'pass_suc',true)
                        state.time = setTimeout(() => {
                            state.currentTask++;
                            handleReset()
                        }, 2500)
                        return
                    }else{
                        //3次任务都通过
                        proxy?.vknMessage.close();
                        Object.assign(state,{
                            currentPage:PageName.成绩
                        })
                        return;
                    }
                }
                state.time = setTimeout(() => {
                    if(isPass){
                        state.currentTask++;
                    }
                    handleReset()
                }, 3100)
            }
        }

        if(type === 'rotatePartOneComplete'){
            showMessage("请改变旋转方向", 3000, 'yjzldy',true)         
        }

        if(type === 'initializeEngineProgress'){
            state.engineProgress = data.data?.progress || 0
        }


        if (type === 'loadSceneResource') {
            //  //加载成功
            // clearInterval(loadingState.timer)
            state.currentPage = 2;
            let windSpeedRange = ''
            state.windDirectionIndex = null
            if(state.taskMode == 1){
                windSpeedRange = state.windSpeed[0].replace("-",",")
                state.windDirectionIndex =  Math.floor(Math.random() * state.windDirction.length)
            }
            state.trainingId = store.state.persistence.currentUavInfo.trainingId;
            state.aiCoachFinal = null;
            state.aiCoachRealtime = null;
            state.aiCoachSettlementData = null;
            state.aiCoachRoundSettlementList = [];
            enterOrExitUavSimulateModule({
                enter:true,
                uavSpecificationId:state.uavId,
                nestId:state.nestId,
                userId:store.state.persistence.userInfo.userId,
                tenantId:store.state.persistence.currentTenantId,
                appId:store.state.persistence.userInfo.appId,
                volume:store.state.persistence.sounds.droneSound,
                forbidAiCoach:state.forbidAiCoach == 1?0:1,
                canvasLimitHeight:getCanvasLimitHeight(store.state.persistence.resolution),
                trainingData:{
                    id:state.trainingId,
                    sceneInfo:state.sceneInfo,
                    windSpeedRange,
                    windDirectionIndex:state.windDirectionIndex,
                    forbidSaveResult:1,
                    specifiedJoystick:store.state.persistence.userTrainSettingInfo.joystickSpecification
                }
            })

        }

         if (type === 'modelLoading') {
             //加载中
             // const { progressData} = data.data || {}
             // loadingState.loadingStatus = progressData
             // initTimer();
             setLoadingStatus(data.data);

         }

         if(type ==='extraLoadModelFiles')
         {
             setExtraFileMap(data.data);
         }

        if(type === 'exitSimulateModuleSuccess'){
            if(state.backByExitSimulateModule){
                handleBack();
            }
        }
    })

    /**
     * 重置
     * @param type
     */
    function handleReset(trainingId?:string, hasUnlockStep = hasFlowStep(flyingState.uavStatusList, '解锁')){
        if(state.forbidAiCoach == 1){
            // 重置曲线数据
            flyDeviationInfoRef?.value?.resetCharts()
            if(state.flyDeviationViewMode == $enum.FlyDeviationViewMode.曲线){
                state.flyDeviationViewMode = $enum.FlyDeviationViewMode.卡片;
            }
        }

        state.aiCoachFinal = null;
        state.aiCoachRealtime = null;
        let windSpeedRange = ''
        let forbidSaveResult = state.currentTask < 3?1:''
        flyingState.resetting = 5;
        state.windDirectionIndex = null
        if(state.taskMode == 1){
            //困难模式
            state.windDirectionIndex =  Math.floor(Math.random() * state.windDirction.length)
            windSpeedRange = state.windSpeed[state.currentTask - 1].replace("-",",")
        }
        Object.assign(flyingState,{
            flyingInfo:{},
            evaluateStatus:{
                height:false,
                position:false,
                time:false,
                angle:false,
                angleMaxSpeed:false,
                angleMinSpeed:false,
                maxSpeed:false,
                minSpeed:false,
                calculateAngleSpeed:false,
                calculateMinSpeed:false,
                collisionAlarm:false,
                onGroundAlarm:false,
            },
            arriveCenter:0,
            isShowAlarm:false
        })
        resetView({
            windSpeedRange,
            windDirectionIndex:state.windDirectionIndex,
            forbidSaveResult,
            trainingId:trainingId || state.trainingId,
        })
        if (timeBox.value) {
            timeBox.value.style.right = `0%`;
        }
        if (progressRef.value) {
            progressRef.value.style.width = `0%`;
        }
        proxy?.vknMessage.close();
        flyingState.currentMessage = MassageType.无;
        stop()
        if(sceneMode.value != SceneMode.悬停 && hasUnlockStep){
            flyingState.currentMessage = MassageType.解锁;
            setTimeout(() => {
                showMessage($tips.OPEN_TIPS, 0,'yjzldy',true)
            }, 1000);
        }
    }

    ///////////////////////////////////////////////////////  状态

    ///////////////////////////////////////////////////////  计算属性
    // 遥控器连接图标
    const connectIcon = computed(() => {
        return state.connectStatus? require("@assets/images/connect.png"): require("@assets/images/disconnect.png")
    })



    const currentTime = computed(() => {
        const progress = flyingState.currentSeconds / flyingState.totalSeconds;
        const remainTime = flyingState.totalSeconds - flyingState.currentSeconds;
        let adjustedRight;

        if (timeBox.value) {
            const rect = timeBox.value.getBoundingClientRect();
            const parentRect = timeBox.value.parentElement.getBoundingClientRect();
            const boxWidth = rect.width;
            const parentWidth = parentRect.width;

            // 计算剩余空间
            const remainingSpace = parentWidth - boxWidth;
            adjustedRight = remainingSpace * progress;
            if(flyingState.currentSeconds > 0){
               timeBox.value.style.right = `${adjustedRight}px`;
            }else if(flyingState.currentSeconds == 0){
                timeBox.value.style.right = `0px`;
            }
        }
        if (progressRef.value) {
            if(flyingState.currentSeconds >= 0){
                progressRef.value.style.width = `${adjustedRight}px`;
            }else if(flyingState.currentSeconds == 0){
                progressRef.value.style.width = `0px`;
            }
        }

        const minutes = Math.floor(remainTime / 60);
        const seconds = (remainTime % 60).toFixed(0);
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    })

    const lockIcon = computed(() => {
        if(state.lockStatus ==  $enum.SWITCH_STATUS.ON){
            return require("@/assets/images/unlock.png");
          }
          return require("@/assets/images/lock.png");
    })



    ///////////////////////////////////////////////////////  监听

    ///////////////////////////////////////////////////////  方法

    const showMessage = (message: string, duration?:number, icon?:string, useVoice?:true | false) => {
        state.isShowMessage = true;
        if(useVoice){
            speak(message)
        }

        proxy?.vknMessage.warning({
            message: message,
            duration:duration !== null && duration !== undefined?duration:3000,
            offset: 100,
            onClose: () => {
                state.isShowMessage = false;
            }
        }, icon)
    }

    const hasFlowStep = (stepNameList:any, keyword:string) => {
        return Array.isArray(stepNameList) && stepNameList.some((step:string) => {
            return typeof step === 'string' && step.includes(keyword)
        })
    }

    const getHoverDirection = (stepNameList:any, currentStepIndex:number) => {
        const stepName = stepNameList?.[currentStepIndex] || state.sceneInfo?.sceneSubTypeName || ''
        return stepName.match(/对尾|对头|对左|对右/)?.[0] || '对尾'
    }

    //普通提示
    const normalPrompt = (options:any)=>{
        let {currentStepIndex,overLimit,stepNameList,arriveCenter,targetTime, isReady} = options || {};
        const hasUnlockStep = hasFlowStep(stepNameList, '解锁')
        const hasLandingStep = hasFlowStep(stepNameList, '降落')
        const canHandleActionStep = Array.isArray(stepNameList) && (currentStepIndex > 0 || !hasUnlockStep) && (hasUnlockStep || isReady)
        const flyToCenterPrompt = hasUnlockStep ? '请提升飞行高度至1.5米以上，并飞至中心桶悬停对尾' : '请保持1.5m以上高度，并飞至中心桶悬停对尾'
        if(sceneMode.value != SceneMode.悬停 && hasUnlockStep && isReady && currentStepIndex == 0 && flyingState.currentMessage == MassageType.无){
            flyingState.currentMessage = MassageType.解锁;
            setTimeout(() => {
                proxy?.vknMessage.close();
                showMessage($tips.OPEN_TIPS, 0,'yjzldy',true)
            }, 500);
        }

        if(sceneMode.value == SceneMode.悬停 && isReady && flyingState.currentMessage == MassageType.无){
            if(state.timer){
                clearTimeout(state.timer);
                state.timer = null;
            }
            proxy?.vknMessage.close();
            flyingState.currentMessage = MassageType.悬停;
            operationPrompt.hoverStarted = false;
            showMessage(`请保持1.5m以上高度，并飞至中心桶悬停${getHoverDirection(stepNameList, currentStepIndex)}`, 0, 'yjzldy',true)
        }

        if(sceneMode.value == SceneMode.悬停 && isReady && arriveCenter && flyingState.currentMessage == MassageType.悬停 && !operationPrompt.hoverStarted){
            const hoverDirection = getHoverDirection(stepNameList, currentStepIndex)
            operationPrompt.hoverStarted = true;
            proxy?.vknMessage.close();
            showMessage(`已到达中心桶，请保持${hoverDirection}`, 3000, 'yjzldy',true)
            if(state.timer){
                clearTimeout(state.timer);
                state.timer = null;
            }
            state.timer = setTimeout(() => {
                proxy?.vknMessage.close();
                showMessage(`开始${hoverDirection}悬停，保持悬停达到${targetTime ?? 30}秒`, 5000, 'yjzldy',true)
            }, 3500);
        }

        if(canHandleActionStep && !state.isShowMessage && overLimit == 0){
            const canStartFirstAction = flyingState.currentMessage == MassageType.解锁 || (!hasUnlockStep && flyingState.currentMessage == MassageType.无)
            if(stepNameList[currentStepIndex] && /自旋/.test(stepNameList[currentStepIndex]) && canStartFirstAction){
                proxy?.vknMessage.close();
                flyingState.currentMessage = MassageType.自转;
                // showMessage("控制无人机到中心桶上方进行360°自旋。", 0, 'yjzldy',true)
                showMessage(flyToCenterPrompt, 0, 'yjzldy',true)
            }

            if(stepNameList[currentStepIndex] && /字/.test(stepNameList[currentStepIndex]) && (canStartFirstAction || flyingState.currentMessage == MassageType.自转)){
                proxy?.vknMessage.close();
                flyingState.currentMessage = MassageType.八字;
                if(sceneMode.value == SceneMode.全科){
                    if(!arriveCenter){
                        operationPrompt.spinCompleted = true;
                        showMessage(`${stepNameList[currentStepIndex - 1]}完成，请飞至中心桶`, 5000, 'yjzldy',true)
                    }
                }else{
                    showMessage(flyToCenterPrompt, 0, 'yjzldy',true)
                }

            }

            if(hasLandingStep && stepNameList[currentStepIndex] && /降落/.test(stepNameList[currentStepIndex]) && (flyingState.currentMessage == MassageType.自转 || flyingState.currentMessage == MassageType.八字)){
                proxy?.vknMessage.close();
                flyingState.currentMessage = MassageType.降落;
                // showMessage("控制无人机降落到地面。", 5000, 'yjzldy',true)
                showMessage("飞行完成，请将无人机降落", 5000, 'yjzldy',true)

            }
            if(arriveCenter && (sceneMode.value != SceneMode.无 && sceneMode.value != SceneMode.悬停)){
                proxy?.vknMessage.close();
                if(sceneMode.value == SceneMode.全科 && flyingState.currentMessage == MassageType.八字){
                    operationPrompt.delayTime = 5000
                    if(operationPrompt.spinCompleted){
                        operationPrompt.spinCompleted = false;
                        showMessage('已到达中心桶，请保持对尾', 5000, 'yjzldy',true)
                    }else{
                        showMessage(`${stepNameList[currentStepIndex - 1]}完成，已到达中心桶，请保持对尾`, 5000, 'yjzldy',true)
                    }
                }else{
                    showMessage('已到达中心桶，请保持对尾', 3000, 'yjzldy',true)
                }
                if(state.timer){
                    clearTimeout(state.timer);
                    state.timer = null;
                }
                state.timer = setTimeout(() => {
                    proxy?.vknMessage.close();
                    showMessage(`${stepNameList[currentStepIndex]}开始，倒计时${targetTime}秒`, 5000, 'yjzldy',true)
                    if(operationPrompt.delayTime == 5000){
                        operationPrompt.delayTime = 3000
                    }
                }, operationPrompt.delayTime);
            }
        }
    }

    //异常提示
    const abnormalPrompt = (data:any)=>{
        if(data?.onGroundAlarm && !flyingState.evaluateStatus.onGroundAlarm){
            flyingState.evaluateStatus.onGroundAlarm = true;
            proxy?.vknMessage.close();
            showMessage("无人机着陆，通关失败，即将重置任务", 3000, 'gjts',true)
        }

        if(data?.overLimit){
            if(!flyingState.isShowAlarm){
                flyingState.isShowAlarm = true;
                proxy?.vknMessage.close();
                showMessage("飞行高度过高，通关失败，即将重置任务", 3000, 'gjts',true)
            }
        }

        if(data?.collisionAlarm && !flyingState.evaluateStatus.collisionAlarm){
            flyingState.evaluateStatus.collisionAlarm = true;
            proxy?.vknMessage.close();
            showMessage("注意障碍物，谨慎飞行", 3000, 'gjts',true)
        }
        if(!data?.collisionAlarm && flyingState.evaluateStatus.collisionAlarm){
            flyingState.evaluateStatus.collisionAlarm = false;
        }

        if(!flyingState.arriveCenter || flyingState.currentMessage == MassageType.降落){
            return
        }

        if(flyingState.evaluateStatus.height || flyingState.evaluateStatus.position || flyingState.evaluateStatus.time || flyingState.evaluateStatus.angle
            || flyingState.evaluateStatus.angleMinSpeed || flyingState.evaluateStatus.angleMaxSpeed || flyingState.evaluateStatus.minSpeed || flyingState.evaluateStatus.maxSpeed
        ){
            return
        }

        const {heightOffset, positionOffset, time, angleOffset, angleSpeedOffset, speedOffset} = data?.evaluateData || {};
        const {mapPosition,mapYaw} = data;

        if(heightOffset){
            if(!flyingState.evaluateStatus.height && heightOffset?.value > heightOffset?.maxValue){
                flyingState.evaluateStatus.height = true;
                proxy?.vknMessage.close();
                showMessage("高度偏差过大，通关失败，即将重置任务", 3000, 'gjts',true)
                state.drawer.drawCircle({
                    x:mapPosition.x,
                    y:mapPosition.y,
                    yaw:mapYaw
                },colorMap["height"]);
            }

        }

        if(positionOffset){
            if(!flyingState.evaluateStatus.position && positionOffset?.value > positionOffset?.maxValue){
                flyingState.evaluateStatus.position = true;
                proxy?.vknMessage.close();
                showMessage("位置偏差过大，通关失败，即将重置任务", 3000, 'gjts',true)
                state.drawer.drawCircle({
                    x:mapPosition.x,
                    y:mapPosition.y,
                    yaw:mapYaw
                },colorMap["position"]);
            }
        }
        if(time && Array.isArray(time) && time.length){
            let timeIndex = Number(flyingState.evaluateStatus.time);
            if (timeIndex < time.length) {
                let needAlarm = false;
                for (let index = timeIndex; index < time.length; index++) {
                    if (time[index]?.value > time[index]?.maxValue) {
                        needAlarm = true;
                        break;
                    }
                }
                if (needAlarm) {
                    flyingState.evaluateStatus.time++;
                    proxy?.vknMessage.close();
                    showMessage("飞行超时，通关失败，即将重置任务", 3000, 'gjts',true)
                    // TODO: 临时修改，超时后结束，便于测试结果页
                    // handleSwitch('reset')
                    state.drawer.drawCircle({
                        x:mapPosition.x,
                        y:mapPosition.y,
                        yaw:mapYaw
                    },colorMap["timeDeviation"]);
                }

            }
        }

        if(angleOffset){
            if(!flyingState.evaluateStatus.angle && angleOffset?.value > angleOffset?.maxValue){
                flyingState.evaluateStatus.angle = true;
                proxy?.vknMessage.close();
                showMessage("航向夹角过大，通关失败，即将重置任务", 3000, 'gjts',true)
                state.drawer.drawCircle({
                    x:mapPosition.x,
                    y:mapPosition.y,
                    yaw:mapYaw
                },colorMap["headAngle"]);
            }
        }

        if(angleSpeedOffset && flyingState.currentMessage == MassageType.自转){
            if(!flyingState.evaluateStatus.angleMinSpeed && angleSpeedOffset?.underMin){
                flyingState.evaluateStatus.angleMinSpeed = true;
                proxy?.vknMessage.close();
                showMessage("角速度过小，通关失败，即将重置任务", 3000, 'gjts',true)
                state.drawer.drawCircle({
                    x:mapPosition.x,
                    y:mapPosition.y,
                    yaw:mapYaw
                },colorMap["angle"]);
            }

            if(!flyingState.evaluateStatus.angleMaxSpeed && angleSpeedOffset?.value > angleSpeedOffset?.maxValue){
                flyingState.evaluateStatus.angleMaxSpeed = true;
                proxy?.vknMessage.close();
                showMessage("角速度过大，通关失败，即将重置任务", 3000, 'gjts',true)
                state.drawer.drawCircle({
                    x:mapPosition.x,
                    y:mapPosition.y,
                    yaw:mapYaw
                },colorMap["angle"]);
            }

        }

        if(speedOffset && flyingState.currentMessage == MassageType.八字){
            if(!flyingState.evaluateStatus.minSpeed && speedOffset?.underMin){
                flyingState.evaluateStatus.minSpeed = true;
                proxy?.vknMessage.close();
                showMessage("速度过小，通关失败，即将重置任务", 3000, 'gjts',true)
                state.drawer.drawCircle({
                    x:mapPosition.x,
                    y:mapPosition.y,
                    yaw:mapYaw
                },colorMap["speed"]);
            }
            if(!flyingState.evaluateStatus.maxSpeed && speedOffset.value > speedOffset.maxValue){
                flyingState.evaluateStatus.maxSpeed = true;
                proxy?.vknMessage.close();
                showMessage("速度过大，通关失败，即将重置任务", 3000, 'gjts',true)
                state.drawer.drawCircle({
                    x:mapPosition.x,
                    y:mapPosition.y,
                    yaw:mapYaw
                },colorMap["speed"]);
            }
        }
    }

    //成绩页面中的重新开始按钮
    async function handleRestart(isBeforeUnload?:false | true){
        window?.playClick()
        const hasUnlockStep = hasFlowStep(flyingState.uavStatusList, '解锁')

        //1. 调用后端接口生成一个训练id
         let param = {
            sceneId:store.state.persistence.currentUavInfo.sceneInfo.id,
            uavSpecificationId:state.uavId,
            userId:store.state.persistence.userInfo.userId,
            stationId:state.stationdId,
        }
        const {code, data} = await createTraining(param);
        if(code != $enum.EnumResult.SUCCESS){
            showMessage("创建新训练失败！")
            return;
        }
        const {trainingId} = data as any || {};
        //2. 通过后端返回的trainingid更新store里面的trainingid
        store.commit('persistence/setCurrentUavInfo', {
            ...store.state.persistence.currentUavInfo,
            trainingId: trainingId
        });
        state.trainingId = trainingId;
        //1. 重置飞行状态页面的状态,
        Object.assign(flyingState,{
            evaluateStatus:{
                height:false,
                position:false,
                time:false,
                angle:false,
                angleMaxSpeed:false,
                angleMinSpeed:false,
                maxSpeed:false,
                minSpeed:false,
                calculateAngleSpeed:false,
                calculateMinSpeed:false,
                collisionAlarm:false,
                onGroundAlarm:false
            },
            totalSeconds: -1, // 飞行总时间 秒
            currentSeconds: 0, // 当前时间 秒
            uavStatusList: [],
            currentStepIndex:0,
            altitude:0,  //高度
            horizonalSpeed:0,//速度
            courseAngle:0, //航向角
            realTimeAngleOffset:flyingState.realTimeAngleOffset !== undefined?0:undefined,//航向夹角
            angularSpeed:0,//角速度
            currentMessage:MassageType.无,
            onGround:false,
            arriveCenter:0,//是否到达中心
            flyingInfo:{},
            uavIconAngle:0
        })
        Object.assign(state,{
            currentTask:1, //当前任务
            allTotalTime:0,
            trainingId:trainingId,
            showElectronic:true,
            aiCoachFinal:null,
            aiCoachRealtime:null,
            aiCoachSettlementData:null,
            aiCoachRoundSettlementList:[]
        })
        //5. 重置进度条
        if (timeBox.value) {
            timeBox.value.style.right = `0%`;
        }
        if (progressRef.value) {
            progressRef.value.style.width = `0%`;
        }
        //6. 关闭成绩页面，打开飞行页面
        if(countdownRef.value){
            countdownRef?.value.reset();
        }
        if(state.forbidAiCoach == 1){
             // 重置曲线数据
            flyDeviationInfoRef?.value?.resetCharts()
            if(state.flyDeviationViewMode == $enum.FlyDeviationViewMode.曲线){
                state.flyDeviationViewMode = $enum.FlyDeviationViewMode.卡片;
            }
        }

        handleReset(trainingId, hasUnlockStep);
        if(isBeforeUnload){
            state.currentPage = PageName.加载中;
        }else{
            state.currentPage = PageName.飞行;
        }
    }


    const handlerResiz = ()=>{
        if(state.drawer){
            state.drawer.resizeHandler(state.lockStatus == $enum.SWITCH_STATUS.OFF);
        }
    }

    function handleBackCallback(type?: string){
        state.backByExitSimulateModule = true;
        enterOrExitUavSimulateModule({enter:false});
    }

    function handleBeforeUnload(e: BeforeUnloadEvent) {
        store.commit("viewData/setEnterScene", false);
        if(state.currentPage == PageName.成绩) {
            handleRestart(true);
        }
        store.commit('persistence/setCurrentUavInfo', {
            ...store.state.persistence.currentUavInfo,
            trainingId: null
        });
    }

    function handleLock(){
        if(state.lockStatus == $enum.SWITCH_STATUS.ON && !flyingState.onGround){
            return;
        }
        let lock = -1;
        if(state.lockStatus == $enum.SWITCH_STATUS.OFF){
            lock = 1;
        }else{
            lock = 0;
        }
        window?.playClick()
        switchUnlockUav({unlock:lock})
    }

    function handleVisibilityChange(){
        if(document.visibilityState == "hidden"){
            state.pageVisible = false;
            state.canSetFps = false;
        }else{
            setTimeout(() => {
                state.pageVisible = true;
            }, 300);
            setTimeout(() => {
                state.canSetFps = true;
            }, 1500);

        }
    }

    function handleKeyDown(event:any)
    {
        if (state.currentPage == PageName.成绩) {
            if (event.key == "Escape") {
                handleBack('Escape');
            }
            return;
        }
        forceGainFocus({key: event.key});
    }

    ///////////////////////////////////////////////////////  生命周期
    onBeforeMount(() => {})
    onMounted(async () => {
        await nextTick();
        if(timeBoxRef.value){
            state.containerWidth = timeBoxRef.value?.offsetWidth;
        }
        window.addEventListener('resize', handlerResiz)
        window.addEventListener('beforeunload', handleBeforeUnload)
        document.addEventListener('visibilitychange', handleVisibilityChange);
        document.addEventListener('keydown', handleKeyDown);
    })

    onBeforeUnmount(() => {
        // if(!state.finish){
        //     deleteTraining({trainingId:state.trainingId})
        // }
        if(!state.backByExitSimulateModule){
            enterOrExitUavSimulateModule({enter:false})
        }
        showOrHideEngineView(false)
        // store.commit('persistence/clearCurrentUavInfo');
        store.commit("viewData/setEnterScene", false);
        // store.commit("persistence/setStationId", null);
        if(state.isShowMessage){
            state.isShowMessage = false;
            proxy?.vknMessage.close();
        }
        if(state.drawer){
            state.drawer.destroy();
        }
        proxy?.vknMessage.close();

        if(state.timer){
            clearTimeout(state.timer);
            state.timer = null;
        }
        store.commit("viewData/setEnterScene", false);
        proxy?.vknMessage.close();
        window.removeEventListener('resize', handlerResiz);
        window.removeEventListener('beforeunload', handleBeforeUnload);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        document.removeEventListener('keydown', handleKeyDown);
        if(state.time) clearTimeout(state.time);
    })

    ///////////////////////////////////////////// 测试

    return {
        ...toRefs(state),
        ...toRefs(loadingState),
        ...toRefs(flyingState),
        $config,
        $enum,
        connectIcon,
        currentTime,
        engineInitialized,
        lockIcon,
        gradTotalTime,
        loadingProgess,
        currentWindDirection,
        currentWindSpeed,
        allPassTime,
        handleBack,
        handleBackCallback,
        handleRestart,
        handleLock,
        handleOpenPDF,
        handleOpenSettingFullscreen
    }
}
